import { getEnv } from '@ctct/ctct-helpers';

import axios from '../../../axiosConfig';

const getBaseUrl = () => {
  if (getEnv() === 'local') {
    return 'https://localhost:9000/v1';
  }

  return `https://app${getEnv()}constantcontact.com/v1`;
};

/* This file was created to allow just the some functions to be available in
 * the myaccount-utils-static library. This was done to avoid refactoring all of
 * MyAccountApi.js (imports, dependencies, unit tests) in myact-react-static. If more
 * functionality is needed in myaccount-utils-static, then we may want to consider just
 * merging all of the MyAccountApi functionality into myaccount-utils-static.
 */

const getUrl = (path) => `${getBaseUrl()}/billing${path[0] !== '/' ? '/' : ''}${path}`;

const BillingSvc = {
  getActivePromotions: () => {
    return axios.get(getUrl('/promotions/active'), {});
  },
  getRecommendedUpgradePlanPromotion: (promoCode) => {
    const params = promoCode ? { promoCode } : {};

    return axios.get(getUrl('/upgradeplan/promotion'), { params });
  },
  setPromotion: ({ promotionCode, username }) =>
    axios.post(getUrl(`/promotion/${promotionCode}?updateBy=${username}`), {}),
};

export default BillingSvc;
